import { LocalizationContextBuilder } from "@amzn/arb-tools";
import { DEFAULT_LOCALE } from "./constants";
import arbManifest from "./translations/arbManifest";

export const getLocalizationContext = (locale: string) => new LocalizationContextBuilder()
    .withLocale(locale || DEFAULT_LOCALE)
    .withDefaultLocale(DEFAULT_LOCALE)
    .build();

const getWidgetBaseUrl = (): string => {
  const script = document.querySelector("script[src*='bundle.js']") as HTMLScriptElement;
  if (!script?.src) return "";
  try {
    return new URL(script.src).origin;
  } catch {
    return "";
  }
};

export const getMbmOptions = (locale: string) => ({
  arbManifest,
  defaultLocalizationContext: getLocalizationContext(locale),
  resolveBundleUrl: (url?: string) => url ? `${getWidgetBaseUrl()}/translations/${url}` : undefined,
});
